/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `Share by email`
};

const fr_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `Partager par e-mail`
};

const de_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `Per E-Mail teilen`
};

const es_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `Compartir por correo electrónico`
};

const it_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `Condividi via email`
};

const ar_share_email_tooltip17 = /** @type {(inputs: {}) => string} */ () => {
	return `المشاركة عبر البريد الإلكتروني`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const share_email_tooltip17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.share_email_tooltip17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("share_email_tooltip17", locale)
	if (locale === "en") return en_share_email_tooltip17(inputs)
	if (locale === "fr") return fr_share_email_tooltip17(inputs)
	if (locale === "de") return de_share_email_tooltip17(inputs)
	if (locale === "es") return es_share_email_tooltip17(inputs)
	if (locale === "it") return it_share_email_tooltip17(inputs)
	return ar_share_email_tooltip17(inputs)
};
export { share_email_tooltip17 as "SHARE_EMAIL_TOOLTIP" }